// extracted by mini-css-extract-plugin
export default {"settingsRow":"settingsRow--QXqxG","subLabel":"subLabel--QvxJz","noBorder":"noBorder--vuQVP"};